export default "__VITE_ASSET__BR7me9GL__"